import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import Animated, {
  useAnimatedStyle,
  withTiming,
} from 'react-native-reanimated';
import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientListItemContainer = memo((props: Props) => {
  const { children, isMuted } = props;

  const animatedStyle = useAnimatedStyle(() => {
    return {
      opacity: withTiming(isMuted ? 0.6 : 1, { duration: theme.transitions.base }), // prettier-ignore
    };
  });

  return (
    <Animated.View
      style={[
        styles.container,
        isMuted ? styles.containerMuted : undefined,
        animatedStyle,
      ]}
    >
      {children}
    </Animated.View>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['4'],
  },
  containerMuted: {
    opacity: 0.6,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  isMuted?: boolean;
}>;
